import { type ComponentProps } from 'react'

import { Badge } from 'slab'

import { type Reimbursement, type ReimbursementState } from './types'

type StateConfig = { label: string; type: ComponentProps<typeof Badge>['type'] }

const stateConfig: Record<ReimbursementState, StateConfig> = {
  draft: { label: 'Draft', type: 'neutral' },
  waiting_for_review: { label: 'Waiting For Review', type: 'caution' },
  confirmed: { label: 'Confirmed', type: 'success' },
  processing: { label: 'Processing', type: 'info' },
  completed: { label: 'Completed', type: 'success' },
  failed: { label: 'Failed', type: 'critical' },
  canceled: { label: 'Canceled', type: 'warning' },
  rejected: { label: 'Rejected', type: 'warning' },
  returned: { label: 'Returned', type: 'warning' },
}

const ReimbursementStateBadge = ({ state }: Reimbursement) => {
  return (
    <Badge type={stateConfig[state].type}>{stateConfig[state].label}</Badge>
  )
}

export default ReimbursementStateBadge
